import React from 'react'
/**
 * ErrorBoundary Component
 * Catches JavaScript errors anywhere in their child component tree,
 * logs those errors, and displays a fallback UI instead of the component tree that crashed.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("ErrorBoundary caught an error:", error, errorInfo);
        
        // Store error info for debugging
        this.errorInfo = {
            error: error.toString(),
            stack: error.stack,
            componentStack: errorInfo.componentStack,
            isServiceWorkerError: error.toString().includes('navigator.serviceWorker') || 
                                error.toString().includes('serviceWorker')
        };
    }

    render() {
        if (this.state.hasError) {
            // Fallback UI
            if (this.errorInfo && this.errorInfo.isServiceWorkerError) {
                return (
                    <div style={{ padding: '20px', textAlign: 'center', marginTop: '50px', fontFamily: 'sans-serif' }}>
                        <h2 style={{ color: '#e53e3e' }}>Service Worker Error</h2>
                        <p>Your browser does not support service workers. Please try a different browser or update your current browser to a version that supports service workers.</p>
                        <button onClick={() => window.location.reload()} style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                            Refresh Page
                        </button>
                    </div>
                );
            } else {
                return (
                    <div style={{ padding: '20px', textAlign: 'center', marginTop: '50px', fontFamily: 'sans-serif' }}>
                        <h2 style={{ color: '#e53e3e' }}>Something went wrong.</h2>
                        <p>The application encountered an unexpected error. Please refresh the page or try again later.</p>
                        <button onClick={() => window.location.reload()} style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                            Refresh Page
                        </button>
                    </div>
                );
            }
        }

        return this.props.children; 
    }
}

export default ErrorBoundary;
